<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="outline-primary"
          :to="{ name: 'roles-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-row>
      <b-col md="4">
        <b-card :title="$t('Role')">
          <b-card-text> Chọn nhiều vai trò cùng lúc để có thêm nhiều quyền khác nhau. </b-card-text>
          <validation-observer
            #default="{ handleSubmit }"
            ref="refFormObserver"
          >
            <!-- Form -->
            <b-form
              class=""
              @submit.prevent="handleSubmit(onSubmit)"
              @reset.prevent="resetForm"
            >
              <!-- Name -->
              <validation-provider
                #default="validationContext"
                :name="$t('Name')"
                rules="required|max:150"
              >
                <b-form-group label-for="name">
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Name') }} <span class="text-danger">*</span></label>
                  </template>
                  <b-form-input
                    id="name"
                    v-model="itemData.name"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <!-- Display Name -->
              <validation-provider
                #default="validationContext"
                :name="$t('Display Name')"
                rules="required|max:150"
              >
                <b-form-group label-for="display_name">
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Display Name') }} <span class="text-danger">*</span></label>
                  </template>
                  <b-form-input
                    id="display_name"
                    v-model="itemData.display_name"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <!-- Form Actions -->
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  type="submit"
                > {{ $t('Save') }} </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
      <b-col md="8">
        <!-- PERMISSIONS -->
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card
            class="border"
            :title="$t('Permission')"
          >
            <b-card-text> Các quyền được cấp theo vai trò. </b-card-text>
            <b-row class="mt-2 mb-2">
              <b-col
                cols="12"
                md="6"
              >
                <b-input-group>
                  <b-form-input
                    v-model="searchPermQuery"
                    class="d-inline-block"
                    placeholder="Từ khóa"
                    @keydown.enter="searchPerm($event)"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      @click.prevent.stop="searchPerm"
                    >
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="text-right"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-dark"
                  @click="selectAll"
                >
                  <feather-icon
                    :icon="resolveCheckedAllIcon()"
                    size="16"
                    class="mr-1"
                  />Chọn hết </b-button>
              </b-col>
            </b-row>
            <b-card-group
              :columns="currentBreakPoint === 'md' || currentBreakPoint === 'lg' || currentBreakPoint === 'xl'"
              :deck="currentBreakPoint === 'xs' || currentBreakPoint === 'sm'"
            >
              <b-card
                v-for="item in listModulePermissions"
                v-if="isShowModule(item)"
                :key="`module_${item.id}`"
                class="border"
                no-body
              >
                <b-card-header>
                  <b-card-title> {{ item.description }} </b-card-title>
                  <b-button
                    variant="flat-dark"
                    size="sm"
                    class="btn-icon"
                    @click="selectAllOne(item.id)"
                  >
                    <feather-icon
                      :icon="resolveCheckedOneIcon(item.id)"
                      size="16"
                    />
                  </b-button>
                </b-card-header>
                <b-card-body>
                  <b-form-group>
                    <div
                      v-for="pem in item.permissions"
                      :key="`pem_${pem.id}`"
                      class="d-flex"
                    >
                      <template v-if="isShowPerm(pem.id)">
                        <b-form-checkbox
                          v-model="selectedPermIds"
                          :value="pem.id"
                          class="mb-1"
                        > {{ `${pem.description} (${pem.name})` }} </b-form-checkbox>
                      </template>
                    </div>
                  </b-form-group>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BTable, BFormCheckbox,
  BCardGroup, BCardText, BInputGroup, BInputGroupAppend, BCardBody,
} from 'bootstrap-vue'
import {
  ref, reactive, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BTable,
    BCardGroup,
    BCardText,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNum,
      max,

      fields: [
        {
          key: 'name',
          label: 'Quyền',
          sortable: false,
        },
        {
          key: 'description',
          label: 'Diễn giải',
          sortable: false,
        },
        {
          key: 'perm_group',
          label: 'Module',
          sortable: false,
        },
        {
          key: 'perm_action',
          label: 'Chọn',
          sortable: false,
          thAttr: { width: '200' },
        },
      ],

    }
  },
  computed: {
    currentBreakPoint() {
      return this.$store.getters['app/currentBreakPoint'];
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'roles-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const searchPermQuery = ref('')
    const searchPermIds = ref([])
    const searchModuleIds = ref([])
    const roleIds = ref([])
    const listModulePermissions = ref([])
    const selectedPermIds = ref([])
    const errorMessage = ref('')
    const permissions = ref([])
    const allSelected = ref(false)
    const oneSelected = ref([])
    const defaultItemData = {
      name: '',
      display_name: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const selectAll = () => {
      searchPermIds.value = [];
      selectedPermIds.value = [];
      searchPermQuery.value = '';
      searchPermQuery.value = '';
      if (!allSelected.value) {
        listModulePermissions.value.forEach(mod => {
          searchModuleIds.value.push(mod.id);
          mod.permissions.forEach(per => {
            selectedPermIds.value.push(per.id);
          });
        });
        searchPermIds.value = selectedPermIds.value;
      } else {
        listModulePermissions.value.forEach(mod => {
          searchModuleIds.value.push(mod.id);
          searchPermIds.value = [];
          selectedPermIds.value = [];
        });
      }
      allSelected.value = !allSelected.value;
    }
    const selectAllOne = (modId) => {
      const index = oneSelected.value.length ? oneSelected.value.indexOf(modId) : -1;
      let checked = false;
      if (index === -1) {
        oneSelected.value.push(modId);
        checked = true;
      } else {
        oneSelected.value.splice(index, 1);
        checked = false;
      }

      if (checked) {
        listModulePermissions.value.forEach(mod => {
          if (mod.id === modId) {
            searchModuleIds.value.push(mod.id);
            mod.permissions.forEach(per => {
              if (!selectedPermIds.value.includes(per.id)) {
                selectedPermIds.value.push(per.id);
              }
            });
          }
        });
      } else {
        listModulePermissions.value.forEach(mod => {
          if (mod.id === modId) {
            searchModuleIds.value.filter((modid) => modid !== modId);
            mod.permissions.forEach(per => {
              const idx = selectedPermIds.value.indexOf(per.id);
              if (idx > -1) {
                selectedPermIds.value.splice(idx, 1);
              }
            });
          }
        });
      }
    }
    const onSubmit = () => {
      // loading.value = true;
      if (layout.value === 'edit') {
        const roleData = {
          name: itemData.value.name,
          display_name: itemData.value.display_name,
          permissions: selectedPermIds.value,
        }
        store.dispatch('roles/updateRole', { id: id.value, roleData })
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'roles-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      } else {
        const roleData = {
          name: itemData.value.name,
          display_name: itemData.value.display_name,
          permissions: selectedPermIds.value,
        }
        store.dispatch('roles/addRole', roleData)
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                resetForm()
                router.push({ name: 'roles-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      }
    }
    const fetchData = () => {
      loading.value = true;
      store.dispatch('roles/fetchRole', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              itemData.value = response.data.data
              const allpems = response.data.data.permissions;
              allpems.forEach((per) => {
                selectedPermIds.value.push(per.id);
              })

              loading.value = false
              errorMessage.value = '';
            } else {
              errorMessage.value = response.message
              loading.value = false
            }
          }
        })
    }
    if (id.value && layout.value === 'edit') {
      fetchData();
    }
    store.dispatch('roles/fetchPermissions', { id: id.value })
      .then(response => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            listModulePermissions.value = response.data.data;
            response.data.data.forEach(mod => {
              searchModuleIds.value.push(mod.id);
              mod.permissions.forEach(per => {
                searchPermIds.value.push(per.id);
              });
            });
          }
        }
      });

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'modules-add') {
          resetItemData();
        } else {
          fetchData();
        }
      },
    )

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      permissions,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      selectAll,
      selectAllOne,
      allSelected,
      oneSelected,
      searchPermQuery,
      searchPermIds,
      searchModuleIds,
      roleIds,
      listModulePermissions,
      selectedPermIds,
    }
  },
  methods: {
    resolveCheckedAllIcon() {
      return this.allSelected ? 'CheckSquareIcon' : 'SquareIcon';
    },
    resolveCheckedOneIcon(modId) {
      return this.oneSelected && this.oneSelected.indexOf(modId) >= 0 ? 'CheckSquareIcon' : 'SquareIcon';
    },
    isShowPerm(permId) {
      if (this.searchPermQuery === '') {
        return true;
      }
      return this.searchPermIds.find((val) => val === permId);
    },

    isShowModule(mod) {
      if (this.searchPermQuery === '') {
        return true;
      }
      return this.searchModuleIds.find((val) => val === mod.id) && mod.permissions.length;
    },

    searchPerm(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.searchPermQuery !== '') {
        this.searchPermIds = [];
        this.searchModuleIds = [];
        this.listModulePermissions.forEach(mod => {
          mod.permissions.forEach(per => {
            if (per.name.toLowerCase().indexOf(this.searchPermQuery) > -1 || per.description.toLowerCase().indexOf(this.searchPermQuery) > -1) {
              this.searchPermIds.push(per.id);
              this.searchModuleIds.push(mod.id);
            }
          });
        });
      } else {
        this.searchModuleIds = [];
        this.listModulePermissions.forEach(mod => {
          this.searchModuleIds.push(mod.id);
          mod.permissions.forEach(per => {
            this.searchPermIds.push(per.id);
          });
        });
      }
    },
  },
}
</script>

<style></style>
